import { useMemo } from 'react';
import FeedbackIconLayer from 'components/gruenland/atoms/button/feedbackIconLayer';
import { Container } from 'components/gruenland/atoms/container/Container';
import { Product } from 'types/entity/product';
import AccumulativeTrace from './components/accumulative-trace';
import Breadcrumbs from './components/breadcrumb';
import Facets from './components/facets/Facets';
import List from './components/list';
import SearchHeader from './components/search-header';
import { useProductList } from './context';

export interface ProductListProps {
  products: Product[];
}

const ProductList: React.FC<ProductListProps> = ({ products }) => {
  const { navigating, slug, searchQuery, categories } = useProductList();

  const category = useMemo(() => categories.find((category) => category.slug === slug), [categories, slug]);

  return (
    <div className="min-h-screen py-[25px]">
      <Container>
        {searchQuery ? (
          <SearchHeader query={searchQuery ?? ''} />
        ) : (
          <Breadcrumbs categories={categories} categoryId={category?.categoryId} />
        )}
      </Container>

      <Container className="relative">
        {/* <MobileFacets /> */}
        <Facets />
        {/* <CurrentRefinements /> */}
        {!navigating && (
          <>
            <List products={products} />
            <AccumulativeTrace currentItems={products.length} />
          </>
        )}
      </Container>
    </div>
  );
};

export default ProductList;
